import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWRMutation from "swr/mutation";
const deleteCustomerLeads = async (ids) =>
  await jwtAxios.delete(URL_API.CMS_CUSTOMER_LEADS.DELETE_CUSTOMER_LEADS, { data: { ids } });

const useDeleteCustomerLeads = () => {
  const fetcher = (_url, { arg }) => deleteCustomerLeads(arg);
  return useSWRMutation(URL_API.CMS_CUSTOMER_LEADS.DELETE_CUSTOMER_LEADS, fetcher);
};

export default useDeleteCustomerLeads;
